import { useTranslations } from "next-intl";
import { Home } from "lucide-react";
import { Link } from "@/i18n/navigation";
import SiteNav from "@/components/SiteNav";

export default function NotFound() {
  const t = useTranslations("notFound");
  return (
    <div className="min-h-screen bg-offwhite">
      <SiteNav />
      <div className="pt-28 flex flex-col items-center justify-center min-h-[70vh] px-6 text-center">
        <div className="w-16 h-16 bg-swiss-red/10 flex items-center justify-center mb-6">
          <span className="text-3xl font-bold text-swiss-red" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{t("code")}</span>
        </div>
        <h1 className="text-2xl font-bold text-graphite mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {t("title")}
        </h1>
        <p className="text-graphite/50 mb-8 max-w-md">
          {t("message")}
        </p>
        <Link href="/" className="inline-flex items-center gap-2 bg-swiss-red text-white px-6 py-3 font-semibold text-sm hover:bg-swiss-red/90 transition-colors">
          <Home size={16} /> {t("backHome")}
        </Link>
      </div>
    </div>
  );
}
